/**
 * @since 7.2.0
 */
export interface ModifyCalendarOptions {
  /**
   * @platform Android, iOS
   * @since 7.2.0
   */
  id: string;
  /**
   * @platform Android, iOS
   * @since 7.2.0
   */
  title?: string;
  /**
   * @platform Android, iOS
   * @example #0000FF
   * @since 7.2.0
   */
  color?: string;
}
